import Loadable from 'my-components/Loadable';

export default Loadable(() => import(/* webpackChunkName: "chats" */ './PopupChatsCtnr'), { hideLoader: true });
